// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__222tp","errorLogs":"styles_errorLogs__23MXG"};